import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { useToken } from '../Contexts/TokenContext';

function HeaderUser() {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const { tokenData } = useToken();
    const navigate = useNavigate();

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('user_id');
        localStorage.removeItem('access_token');
        localStorage.removeItem('user_type');

        navigate('/login');
    };

    return (
        <div className="relative lg:ml-4" ref={dropdownRef}>
            <button
                className="hidden group lg:flex items-center bg-neutral-800 p-1.5 rounded-full"
                href="#"
                onClick={(e) => {
                    e.preventDefault();
                    setDropdownOpen(!dropdownOpen);
                }}
            >
                <span className="w-11 h-11 rounded-full bg-secondary flex items-center justify-center">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        className="fill-black"
                    >
                        <defs>
                            <clipPath id="circle-clip">
                                <circle id="circle-shape" cx="15" cy="15" r="15" transform="translate(1602 47)" />
                            </clipPath>
                        </defs>

                        <g id="masked-group" transform="translate(-1602 -47)" clipPath="url(#circle-clip)">
                            <path
                                id="user-icon"
                                d="M21.316,4.737a7.895,7.895,0,1,0,7.895,7.895A7.895,7.895,0,0,0,21.316,4.737Zm0,12.632a4.737,4.737,0,1,1,4.737-4.737A4.737,4.737,0,0,1,21.316,17.368ZM35.526,34.737V33.158A11.053,11.053,0,0,0,24.474,22.105H18.158A11.053,11.053,0,0,0,7.105,33.158v1.579h3.158V33.158a8.092,8.092,0,0,1,1.467-4.585,7.751,7.751,0,0,1,6.428-3.31h6.316a7.9,7.9,0,0,1,7.895,7.895v1.579Z"
                                transform="translate(1595.684 42.263)"
                            />
                        </g>
                    </svg>
                </span>

                <svg
                    className={`hidden fill-white opacity-50 group-hover:opacity-100 transition-all sm:block ${dropdownOpen ? 'rotate-180' : ''} mx-3`}
                    width="12"
                    height="8"
                    viewBox="0 0 12 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0.410765 0.910734C0.736202 0.585297 1.26384 0.585297 1.58928 0.910734L6.00002 5.32148L10.4108 0.910734C10.7362 0.585297 11.2638 0.585297 11.5893 0.910734C11.9147 1.23617 11.9147 1.76381 11.5893 2.08924L6.58928 7.08924C6.26384 7.41468 5.7362 7.41468 5.41077 7.08924L0.410765 2.08924C0.0853277 1.76381 0.0853277 1.23617 0.410765 0.910734Z"
                        fill=""
                    />
                </svg>
            </button>
            {dropdownOpen && (
                <div className="absolute left-10 -translate-x-1/2 mt-4 flex w-52 flex-col rounded-md border border-secondary bg-white shadow-default">
                    <span className="text-center lg:block py-2 bg-secondary border-b border-slate-300">
                        <span className="block font-medium">{tokenData.nome}</span>
                        <span className="block text-xs text-white">Membro</span>
                    </span>

                    <ul className="flex flex-col gap-5 border-b border-stroke">
                        <li>
                            <Link
                                to="/painel/perfil"
                                className="flex items-center gap-3 px-6 py-2 sm:py-4 text-sm font-medium ease-in-out hover:bg-slate-100 lg:text-base"
                            >
                                <svg
                                    className="fill-current"
                                    width="22"
                                    height="22"
                                    viewBox="0 0 22 22"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M11 9.62499C8.42188 9.62499 6.35938 7.59687 6.35938 5.12187C6.35938 2.64687 8.42188 0.618744 11 0.618744C13.5781 0.618744 15.6406 2.64687 15.6406 5.12187C15.6406 7.59687 13.5781 9.62499 11 9.62499ZM11 2.16562C9.28125 2.16562 7.90625 3.50624 7.90625 5.12187C7.90625 6.73749 9.28125 8.07812 11 8.07812C12.7188 8.07812 14.0938 6.73749 14.0938 5.12187C14.0938 3.50624 12.7188 2.16562 11 2.16562Z" />
                                    <path d="M17.7719 21.4156H4.2281C3.5406 21.4156 2.9906 20.8656 2.9906 20.1781V17.0844C2.9906 13.7156 5.7406 10.9656 9.10935 10.9656H12.925C16.2937 10.9656 19.0437 13.7156 19.0437 17.0844V20.1781C19.0094 20.8312 18.4594 21.4156 17.7719 21.4156ZM4.53748 19.8687H17.4969V17.0844C17.4969 14.575 15.4344 12.5125 12.925 12.5125H9.07498C6.5656 12.5125 4.5031 14.575 4.5031 17.0844V19.8687H4.53748Z" />
                                </svg>
                                Meu Perfil
                            </Link>
                        </li>
                    </ul>
                    <button
                        onClick={handleLogout}
                        className="flex items-center gap-3 px-6 py-2 sm:py-4 text-sm font-medium ease-in-out hover:bg-slate-100 lg:text-base"
                    >
                        <svg
                            className="fill-current"
                            width="22"
                            height="22"
                            viewBox="0 0 22 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M15.5375 0.618744H11.6531C10.7594 0.618744 10.0031 1.37499 10.0031 2.26874V4.64062C10.0031 5.05312 10.3469 5.39687 10.7594 5.39687C11.1719 5.39687 11.55 5.05312 11.55 4.64062V2.23437C11.55 2.16562 11.5844 2.13124 11.6531 2.13124H15.5375C16.3625 2.13124 17.0156 2.78437 17.0156 3.60937V18.3562C17.0156 19.1812 16.3625 19.8344 15.5375 19.8344H11.6531C11.5844 19.8344 11.55 19.8 11.55 19.7312V17.3594C11.55 16.9469 11.2062 16.6031 10.7594 16.6031C10.3125 16.6031 10.0031 16.9469 10.0031 17.3594V19.7312C10.0031 20.625 10.7594 21.3812 11.6531 21.3812H15.5375C17.2219 21.3812 18.5625 20.0062 18.5625 18.3562V3.64374C18.5625 1.95937 17.1875 0.618744 15.5375 0.618744Z" />
                            <path d="M6.05001 11.7563H12.2031C12.6156 11.7563 12.9594 11.4125 12.9594 11C12.9594 10.5875 12.6156 10.2438 12.2031 10.2438H6.08439L8.21564 8.07813C8.52501 7.76875 8.52501 7.2875 8.21564 6.97812C7.90626 6.66875 7.42501 6.66875 7.11564 6.97812L3.67814 10.4844C3.36876 10.7938 3.36876 11.275 3.67814 11.5844L7.11564 15.0906C7.25314 15.2281 7.45939 15.3312 7.66564 15.3312C7.87189 15.3312 8.04376 15.2625 8.21564 15.125C8.52501 14.8156 8.52501 14.3344 8.21564 14.025L6.05001 11.7563Z" />
                        </svg>
                        Log Out
                    </button>
                </div>
            )}

            <div className="lg:hidden flex flex-col w-full pb-6 mb-6 sm:pb-8 sm:mb-8 border-b">
                <span className="block text-center lg:block pt-16 pb-4 mb-4 bg-secondary">
                    <span className="block w-fit mx-auto mb-5 bg-neutral-800 p-1.5 rounded-full">
                        <span className="w-11 h-11 rounded-full bg-white flex items-center justify-center">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                width="30"
                                height="30"
                                viewBox="0 0 30 30"
                                className="fill-black"
                            >
                                <defs>
                                    <clipPath id="circle-clip">
                                        <circle id="circle-shape" cx="15" cy="15" r="15" transform="translate(1602 47)" />
                                    </clipPath>
                                </defs>

                                <g id="masked-group" transform="translate(-1602 -47)" clipPath="url(#circle-clip)">
                                    <path
                                        id="user-icon"
                                        d="M21.316,4.737a7.895,7.895,0,1,0,7.895,7.895A7.895,7.895,0,0,0,21.316,4.737Zm0,12.632a4.737,4.737,0,1,1,4.737-4.737A4.737,4.737,0,0,1,21.316,17.368ZM35.526,34.737V33.158A11.053,11.053,0,0,0,24.474,22.105H18.158A11.053,11.053,0,0,0,7.105,33.158v1.579h3.158V33.158a8.092,8.092,0,0,1,1.467-4.585,7.751,7.751,0,0,1,6.428-3.31h6.316a7.9,7.9,0,0,1,7.895,7.895v1.579Z"
                                        transform="translate(1595.684 42.263)"
                                    />
                                </g>
                            </svg>
                        </span>
                    </span>
                    <span className="block font-medium">{tokenData.nome}</span>
                    <span className="block text-xs text-white">Membro</span>
                </span>

                <ul className="flex flex-col items-center gap-5">
                    <li>
                        <Link
                            to="/painel/perfil"
                            className="flex items-center gap-3 px-6 py-2 sm:py-4 text-sm text-white font-medium ease-in-out lg:text-base"
                        >
                            <svg
                                className="fill-current"
                                width="22"
                                height="22"
                                viewBox="0 0 22 22"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M11 9.62499C8.42188 9.62499 6.35938 7.59687 6.35938 5.12187C6.35938 2.64687 8.42188 0.618744 11 0.618744C13.5781 0.618744 15.6406 2.64687 15.6406 5.12187C15.6406 7.59687 13.5781 9.62499 11 9.62499ZM11 2.16562C9.28125 2.16562 7.90625 3.50624 7.90625 5.12187C7.90625 6.73749 9.28125 8.07812 11 8.07812C12.7188 8.07812 14.0938 6.73749 14.0938 5.12187C14.0938 3.50624 12.7188 2.16562 11 2.16562Z" />
                                <path d="M17.7719 21.4156H4.2281C3.5406 21.4156 2.9906 20.8656 2.9906 20.1781V17.0844C2.9906 13.7156 5.7406 10.9656 9.10935 10.9656H12.925C16.2937 10.9656 19.0437 13.7156 19.0437 17.0844V20.1781C19.0094 20.8312 18.4594 21.4156 17.7719 21.4156ZM4.53748 19.8687H17.4969V17.0844C17.4969 14.575 15.4344 12.5125 12.925 12.5125H9.07498C6.5656 12.5125 4.5031 14.575 4.5031 17.0844V19.8687H4.53748Z" />
                            </svg>
                            Meu Perfil
                        </Link>
                    </li>
                </ul>
                <button
                    onClick={handleLogout}
                    className="flex items-center justify-center gap-3 px-6 py-2 sm:py-4 text-sm text-white font-medium ease-in-out lg:text-base"
                >
                    <svg className="fill-current" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.5375 0.618744H11.6531C10.7594 0.618744 10.0031 1.37499 10.0031 2.26874V4.64062C10.0031 5.05312 10.3469 5.39687 10.7594 5.39687C11.1719 5.39687 11.55 5.05312 11.55 4.64062V2.23437C11.55 2.16562 11.5844 2.13124 11.6531 2.13124H15.5375C16.3625 2.13124 17.0156 2.78437 17.0156 3.60937V18.3562C17.0156 19.1812 16.3625 19.8344 15.5375 19.8344H11.6531C11.5844 19.8344 11.55 19.8 11.55 19.7312V17.3594C11.55 16.9469 11.2062 16.6031 10.7594 16.6031C10.3125 16.6031 10.0031 16.9469 10.0031 17.3594V19.7312C10.0031 20.625 10.7594 21.3812 11.6531 21.3812H15.5375C17.2219 21.3812 18.5625 20.0062 18.5625 18.3562V3.64374C18.5625 1.95937 17.1875 0.618744 15.5375 0.618744Z" />
                        <path d="M6.05001 11.7563H12.2031C12.6156 11.7563 12.9594 11.4125 12.9594 11C12.9594 10.5875 12.6156 10.2438 12.2031 10.2438H6.08439L8.21564 8.07813C8.52501 7.76875 8.52501 7.2875 8.21564 6.97812C7.90626 6.66875 7.42501 6.66875 7.11564 6.97812L3.67814 10.4844C3.36876 10.7938 3.36876 11.275 3.67814 11.5844L7.11564 15.0906C7.25314 15.2281 7.45939 15.3312 7.66564 15.3312C7.87189 15.3312 8.04376 15.2625 8.21564 15.125C8.52501 14.8156 8.52501 14.3344 8.21564 14.025L6.05001 11.7563Z" />
                    </svg>
                    Log Out
                </button>
            </div>
        </div>
    );
}

export default HeaderUser;
